import sendGtag from '@pt/utils/send-gtag.js'

const trial = {
  namespaced: true,
  state: {
    trialApplyDialogVisible: false,
  },
  mutations: {
    updateApplyDialogVisible(state, value) {
      state.trialApplyDialogVisible = value
    },
  },
  actions: {
    toggleDialogVisible({ commit, state }) {
      if (!state.trialApplyDialogVisible) {
        sendGtag({ name: 'free_trial_start' })
      }
      commit('updateApplyDialogVisible', !state.trialApplyDialogVisible)
    },
  },
}

export default trial
